<div class="dialog-wrapper">
  <div mat-dialog-content>
    @for (factor of factors; track factor) {
      <div>
        <div class="cursor-pointer" [ngClass]="{ 'last-damping-factor' : factor === data.selectedDampingFactor }" (click)="selectFactor(factor)">{{ factor }} % </div>
      </div>
    }
  </div>
</div>
